import { createContext, useContext } from 'react';

interface MonitorMode {
  isKiosk: boolean;
}

// Default to kiosk so components outside the monitor (tablet views, etc.) are unchanged
const MonitorModeContext = createContext<MonitorMode>({ isKiosk: true });

export const MonitorModeProvider = MonitorModeContext.Provider;

export const useMonitorMode = () => useContext(MonitorModeContext);
